export default __webpack_public_path__ + "static/media/armydreamers.e50f90cb.jpg";